/**
 * Created by neo on 01.05.22.
 */
import { makeAutoObservable } from 'mobx';

export type ScheduleMarkedDateJson = {
  date: string;
  counts: Record<string, number>;
};

export type ScheduleMarkedDate = ScheduleMarkedDateJson & {
  getCategoryCount(category: string): number;
  hasCategory(category: string): boolean;
};

export function createScheduleMarkedDate(json?: Partial<ScheduleMarkedDateJson>): ScheduleMarkedDate {
  return makeAutoObservable({
    date: json?.date ?? '',
    counts: json?.counts ?? {},

    getCategoryCount(category: string): number {
      return this.counts[category] ?? 0;
    },

    hasCategory(category: string): boolean {
      return this.getCategoryCount(category) > 0;
    },
  });
}
